/**
 * @generated SignedSource<<8e556062268c98bf1d670eafa70c58d9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DelegateFromListRowFragment$data = {
  readonly tokenHoldersRepresentedCount: number;
  readonly " $fragmentType": "DelegateFromListRowFragment";
};
export type DelegateFromListRowFragment$key = {
  readonly " $data"?: DelegateFromListRowFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"DelegateFromListRowFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DelegateFromListRowFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tokenHoldersRepresentedCount",
      "storageKey": null
    }
  ],
  "type": "DelegateMetrics",
  "abstractKey": null
};

(node as any).hash = "cc0ed38e686de9dbf0aa53f1ebd75f38";

export default node;
